"use client";

import Image from "next/image";
import React from "react";

interface MobileGridPageStickyNavProps {
  isGridView?: boolean;
  onSortToggle?: () => void;
  onFilterToggle?: () => void;
  onGridViewToggle?: () => void;
}

const MobileGridPageStickyNav: React.FC<MobileGridPageStickyNavProps> = ({
  isGridView = true,
  onSortToggle,
  onFilterToggle,
  onGridViewToggle,
}) => {
  return (
    <div className="w-full h-full flex justify-start items-center gap-6 px-4 py-3">
      {/* SORT BY Button */}
      <button
        onClick={onSortToggle}
        className="flex-1 px-3 py-2.5 bg-white border border-black flex justify-center items-center gap-3 hover:bg-light-grey transition-colors"
      >
        <div className="text-center text-black text-base font-raleway font-bold tracking-[1.6px]">
          SORT BY
        </div>
      </button>

      {/* FILTER BY Button */}
      <button
        onClick={onFilterToggle}
        className="flex-1 px-3 py-2.5 bg-white border border-black flex justify-center items-center gap-3 hover:bg-light-grey transition-colors"
      >
        <div className="text-center text-black text-base font-raleway font-bold tracking-[1.6px]">
          FILTER BY
        </div>
      </button>

      {/* Grid Toggle Icon */}
      {onGridViewToggle && (
        <div className="w-6 h-6 flex items-center justify-center cursor-pointer">
          <button
            onClick={onGridViewToggle}
            className="w-11 h-11 flex items-center justify-center hover:opacity-70 transition-opacity cursor-pointer"
          >
            <Image
              src={isGridView ? "/icons/grid-view-1x1.svg" : "/icons/grid-view-2x2.svg"}
              alt={isGridView ? "Switch to list view" : "Switch to grid view"}
              width={24}
              height={24}
              className="w-6 h-6"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileGridPageStickyNav;
